export const FETCH_REQUEST = "PRODUCTS_FETCH_REQUEST";
export const FETCH_SUCCESS = "PRODUCTS_FETCH_SUCCESS";
export const FETCH_FAILURE = "PRODUCTS_FETCH_FAILURE";

export const INSERT = "PRODUCTS_INSERT";

export const DELETE_SUCCESS = "PRODUCTS_DELETE_SUCCESS";
